import { Directive, ElementRef, inject, OnInit, Renderer2 } from "@angular/core";
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: "[Asterisk]",
  standalone: false,
})
export class AsteriskDirective implements OnInit {
  private readonly renderer = inject(Renderer2);
  private readonly el = inject(ElementRef);

  constructor() {}

  ngOnInit() {
    const span = this.renderer.createElement("span") as HTMLSpanElement;
    const text = this.renderer.createText("*");
    span.className = "asterisk";
    span.style.color = "red";
    span.style.fontSize = "14px";
    span.style.marginLeft = "5px";
    span.appendChild(text);
    this.el.nativeElement.appendChild(span);
  }
}
